/* tslint:disable */
/* eslint-disable */
/**
 * NLBS SDPS Secure Zone API
 * NLBS SDPS Secure Zone API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  KeysResponseBody,
} from '../models';
import {
    KeysResponseBodyFromJSON,
    KeysResponseBodyToJSON,
} from '../models';

/**
 * SearchApi - interface
 * 
 * @export
 * @interface SearchApiInterface
 */
export interface SearchApiInterface {
    /**
     * Get search-only Typesense API keys.
     * @summary keys search
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SearchApiInterface
     */
    searchKeysRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<KeysResponseBody>>;

    /**
     * Get search-only Typesense API keys.
     * keys search
     */
    searchKeys(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<KeysResponseBody>;

}

/**
 * 
 */
export class SearchApi extends runtime.BaseAPI implements SearchApiInterface {

    /**
     * Get search-only Typesense API keys.
     * keys search
     */
    async searchKeysRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<KeysResponseBody>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2_header_Authorization", []);
        }

        const response = await this.request({
            path: `/search/keys`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => KeysResponseBodyFromJSON(jsonValue));
    }

    /**
     * Get search-only Typesense API keys.
     * keys search
     */
    async searchKeys(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<KeysResponseBody> {
        const response = await this.searchKeysRaw(initOverrides);
        return await response.value();
    }

}
